import React from 'react';
import {Flex, PaymentModal} from '/app/src/component';
import Modal from 'react-responsive-modal';

import PricingPlan from '/app/src/container/Company/PricingPlan'

class DashboardCompany extends React.Component
{
    constructor(props) {
        super(props)

        //Default values
        this.state = {
            showModal: false
        }
    }

    //This text is overridden in the PricingPlan component.
    _hoverText(activePlan) {
        if (activePlan === "start" || activePlan === "standard") return "Uppgradera"
        else return "Nedgradera"
    }

    _hoverIcon(activePlan) {
        if (activePlan === "start") return "/images/upgrade.svg"
        else return ""
    }

    render() {
        const {showModal} = this.state
        const {activePlan} = this.props
        const pricingStyle = {
            marginLeft: '30px',
            width: '360px',
            height: '960px',
            marginTop: '20px'
        }

        const modalStyle = {
            'modal': {
                'padding': '0px',
                'borderRadius' : '20px',
                'overflow': 'hidden'
            }
        }

        const containerStyle = {
            padding: '0px 30px 30px 0px',
            hAlignContent:'center',
            backgroundColor: 'LightGray1',
            overflowY: 'auto',
            dataName: 'MainPanelPricingUpgrade'
        }

        return (
            <Flex wrap {...containerStyle} grow overflowY='auto'>
                <Flex {...pricingStyle}>
                    <PricingPlan
                    plan='Start'
                    onClick={() => this.setState({showModal: true})}
                    isActive={activePlan === 'start' || activePlan === 'standard'}
                    hoverText={this._hoverText(activePlan)}/>
                </Flex>
                <Flex {...pricingStyle}>
                    <PricingPlan
                    plan='Pro'
                    onClick={() => this.setState({showModal: true})}
                    isActive={activePlan === 'pro'}
                    activePlan={activePlan}
                    hoverText={this._hoverText(activePlan)}
                    hoverIcon={this._hoverIcon(activePlan)}/>
                </Flex>
                <Modal styles={modalStyle} open={showModal} onClose={() => this.setState({showModal: false})}>
                    <PaymentModal onClose={() => this.setState({showModal: false})}/>
                </Modal>
            </Flex>
        )
    }

}

export default DashboardCompany;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/CompanySettings/Upgrade/DashboardCompany.js